import pathOr from 'ramda/src/pathOr';
export default function getErrorFromResponse(error) {
  return pathOr(null, ['response', 'data', 'error'], error);
}